// components/ProductMappingModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
//API 
import { PosIntegrationFetchAPI } from "../../../api/PosIntegrations";
export default function ProductMappingModal({
  show,
  onHide,
  unlinkedProducts,
  unlinkedSegments,
  unlinkedItems,
  platform,
  branchofficeId,
  token,
  onMappingsSaved
}) {
  //State
  const [mappings, setMappings] = useState([]);
  const [segmentMappings, setSegmentMappings] = useState([]);
  const [itemMappings, setItemMappings] = useState([]);
  //We get the smartpay products 
  let generalData = localStorage.getItem('generalData');
  let generalDataParse = JSON.parse(generalData);
  let smartpayProducts = generalDataParse[0].data.groups;
  let smartpaySegments = generalDataParse[0].data.segments;
  let smartpayItems = generalDataParse[0].data.items;

  const getExternalDeliveryId = (entity = {}) =>
    entity.external_data || entity.id || entity.remoteCode || entity.external_id || entity.externalId;

  //We filter the smartpay products to get only the ones that are not linked
  const handleProductChange = (externalId, productId) => {
    // We get the smartpay product that is not linked
    setMappings((prev) => {
      return [...prev, {
        external_id: externalId,
        group_id: productId,
        branchoffice_id: branchofficeId,
        platform: platform,
        pos_integration_id: platform === "PEDIDOSYA" ? 5 : 4,
      }]
    });
  };

  const handleSegmentMap = (externalId, internalSegmentId) => {
    setSegmentMappings(prev => [
      ...prev.filter(m => m.external_id !== externalId),
      {
        external_id: externalId,
        platform,
        branchoffice_id: branchofficeId,
        segment_id: parseInt(internalSegmentId),
        pos_integration_id: platform === "PEDIDOSYA" ? 5 : 4
      }
    ]);
  };

  const handleItemMap = (externalId, internalItemId) => {
    setItemMappings(prev => [
      ...prev.filter(m => m.external_id !== externalId),
      {
        external_id: externalId,
        platform,
        branchoffice_id: branchofficeId,
        item_id: parseInt(internalItemId),
        pos_integration_id: platform === "PEDIDOSYA" ? 5 : 4
      }
    ]);
  };

  const handleSubmit = async () => {
    const saved = await handleSaveMappings(mappings);
    if (saved) {
      onMappingsSaved?.();
      onHide();
    }
  };


  //Function to save the mappings
  const handleSaveMappings = async (mappings) => {
    try {
      console.log("Segment mappings:", segmentMappings);
      console.log("Item mappings:", itemMappings);
      if (segmentMappings.length > 0) {
        mappings = [...mappings, ...segmentMappings];
      }
      if (itemMappings.length > 0) {
        mappings = [...mappings, ...itemMappings];
      }
      console.log("Enviando al backend:", mappings);

      //We save the mappings to the backend
      await PosIntegrationFetchAPI.assignProductToPosIntegration(mappings, token);
      // Guardar en localStorage
      let localData = JSON.parse(localStorage.getItem("generalData"));
      if (!localData || !localData[0]?.data?.groups) return;
      // Asegurarse de que localData tenga la estructura correcta
      mappings.forEach(mapping => {
        const {
          external_id,
          group_id,
          combo_id = null,
          branchoffice_id,
          platform,
          pos_integration_id
        } = mapping;

        const group = localData[0].data.groups.find(g => g.group_id === parseInt(group_id));
        if (!group) return;

        // Inicializar el array si no existe
        if (!Array.isArray(group.externalIntegrationIds)) {
          group.externalIntegrationIds = [];
        }

        // Verificar si ya está mapeado ese external_id
        const alreadyMapped = group.externalIntegrationIds.some(e => e.external_id === external_id && e.platform === platform);
        if (!alreadyMapped) {
          group.externalIntegrationIds.push({
            id: Date.now(), // Puedes usar un id temporal para frontend si deseas
            external_product_name: null,
            platform,
            branchoffice_id,
            group_id,
            combo_id,
            createdAt: new Date().toISOString(),
            external_id,
            pos_integration_id
          });
        }
      });

      // Guardar segmentos en localStorage
      if (segmentMappings.length > 0) {
        const existingSegments = localData[0].data.externalDeliverySegments || [];
        const updatedSegments = [...existingSegments];

        segmentMappings.forEach(mapping => {
          const exists = updatedSegments.some(m => m.external_id === mapping.external_id && m.platform === mapping.platform);
          if (!exists) {
            updatedSegments.push({
              id: Date.now(),
              external_product_name: null,
              ...mapping,
              combo_id: null,
              group_id: null,
              item_id: null,
              createdAt: new Date().toISOString()
            });
          }
        });

        localData[0].data.externalDeliverySegments = updatedSegments;
      }

      // Guardar ítems en localStorage
      if (itemMappings.length > 0) {
        const existingItems = localData[0].data.externalDeliveryItems || [];
        const updatedItems = [...existingItems];

        itemMappings.forEach(mapping => {
          const exists = updatedItems.some(m => m.external_id === mapping.external_id && m.platform === mapping.platform);
          if (!exists) {
            updatedItems.push({
              id: Date.now(),
              external_product_name: null,
              ...mapping,
              combo_id: null,
              group_id: null,
              segment_id: null,
              createdAt: new Date().toISOString()
            });
          }
        });

        localData[0].data.externalDeliveryItems = updatedItems;
      }
      // Guardar nuevamente
      localStorage.setItem("generalData", JSON.stringify(localData));
      console.log("Mapeos guardados en localStorage:", localData);
      return true;

    } catch (err) {
      console.error("Error guardando mapeos:", err);
      return false;
    }
  };

  //We clean the map states 
  useEffect(() => {
    if (show) {
      setMappings([]);
      setSegmentMappings([]);
      setItemMappings([]);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable backdrop="static" >
      <Modal.Header>
        <Modal.Title>Relacionar productos externos</Modal.Title>
      </Modal.Header> 
      <Modal.Body>
        <Table bordered hover>
          <thead>
            <tr>
              <th>Producto externo</th>
              <th>Producto interno</th>
            </tr>
          </thead>
          <tbody>
            {unlinkedProducts.map((product, idx) => (
              <React.Fragment key={idx}>
                <tr>
                  <td>
                    <strong>{product.name ? product.name : product.title}</strong>
                  </td>
                  <td>
                    <Form.Select
                      onChange={(e) => handleProductChange(getExternalDeliveryId(product), e.target.value)}
                    //value={product}
                    >
                      <option value="">Selecciona producto</option>
                      {smartpayProducts.map((p) => (
                        <option key={p.group_id} value={p.group_id}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>

        {/* 🔶 Segmentos no mapeados */}
        {unlinkedSegments.length > 0 && (
          <>
            <h6 className="mt-4">Mapear Segmentos Externos</h6>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Segmento externo</th>
                  <th>Segmento interno</th>
                </tr>
              </thead>
              <tbody>
                {unlinkedSegments.map((segment, idx) => (
                  <tr key={`segment-${idx}`}>
                    <td>{segment.title || segment.name}</td>
                    <td>
                      <Form.Select
                        onChange={(e) =>
                          handleSegmentMap(getExternalDeliveryId(segment), e.target.value)
                        }
                      >
                        <option value="">Selecciona segmento</option>
                        {smartpaySegments.map((s) => (
                          <option key={"segment" + s.segment_id + "id"} value={s.segment_id}>
                            {s.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {/* 🔷 Ítems no mapeados */}
        {unlinkedItems.length > 0 && (
          <>
            <h6 className="mt-4">Mapear Ítems Externos</h6>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Ítem externo</th>
                  <th>Ítem interno</th>
                </tr>
              </thead>
              <tbody>
                {unlinkedItems.map((item, idx) => (
                  <tr key={`item-${idx}`}>
                    <td>{item.title || item.name}</td>
                    <td>
                      <Form.Select
                        onChange={(e) =>
                          handleItemMap(getExternalDeliveryId(item), e.target.value)
                        }
                      >
                        <option value="">Selecciona ítem</option>
                        {/* Aquí puedes poblar con tus ítems disponibles */}
                        {smartpayItems.map((i) => (
                          <option key={"item" + i.item_id + "id"} value={i.item_id}>
                            {i.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}


      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar relaciones
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
